// components/Sign/Sign.js
import React, { useState } from 'react';
import api from '../../services/api';
import { Input } from '../UI/Input.js';
import { Button } from '../UI/Button.js';
import styled from 'styled-components';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';

const Sign = () => {
  const [pin, setPin] = useState('');

  const handleSign = async () => {
    try {
      await api.post(`/sign/${pin}`);
      alert('Signed successfully!');
      setPin('');
    } catch (error) {
      console.error('Signing failed', error);
      alert('Signing failed. Please check the PIN.');
    }
  };

  return (
    <div>
      <h2>Fichar entrada/salida</h2>
	  <FormContainer>
      <Input type="text" placeholder="PIN" value={pin} onChange={(e) => setPin(e.target.value)} />
	  <FullWidth>
      <Button onClick={handleSign}>Fichar</Button>
	  </FullWidth>
	  </FormContainer>
    </div>
  );
};

export default Sign;